import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import JensListComponent from "../../../components/Definition/Jens/JensListComponent";
import { deleteJens, getJensList } from "../../../actions/reports/reports";

export default function JensScreen() {
    const [jens, setJens] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getJensList(params.toString());
                setLoading(false);
                setJens(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <JensListComponent lists={jens} deleteJens={async(id)=>{
                const prompt = window.confirm("آیا میخواهید کالا حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteJens(id);
                    if (response.status === "success") {
                        toast.success("کالا حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف کالا");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
